module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hres80x",
    attrs: {
      "name": "hres80x"
    }
  }, [_c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('history-heal-illness1', {
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "dataHisHeal": _vm.hisHeal
    }
  }), _vm._v(" "), _c('history-heal-illness2', {
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "dataHisHealDetail": _vm.hisHealDetail
    }
  }), _vm._v(" "), _c('history-heal-family', {
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "dataHisHealFamily": _vm.hisHealFamily
    }
  }), _vm._v(" "), _c('history-heal-others', {
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "dataHisHeal": _vm.hisHeal
    }
  }), _vm._v(" "), _c('heal-checkup', {
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "healCheckupHeader": _vm.healCheckupHeader,
      "healCheckupDetail": _vm.healCheckupDetail,
      "healCheckupRows": _vm.healCheckupRows
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aa101262!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres80x/component.vue
// module id = 3953
// module chunks = 1